import React, { useState } from 'react';
import { motion } from 'framer-motion';

function TableArea({
  box,
  allowClick,
  sameBox,
  defaultBox,
  handleBoxUiClick,
  coords,
  actualAdd,
  actualAddH,
}) {
  const [hoverAc, setHoverAc] = useState(false);
  const [x, y, r] = coords;

  const tableFramer = {
    hidden: { opacity: 0 },
    visible: { scale: 1, opacity: 1 },
    hover: { scale: 1.2, opacity: 1 },
    tap: { scale: 0.8, originX: 0 },
  };

  const bgColor = () => {
    if (sameBox) {
      return 'green';
    } else if (!allowClick) {
      return 'red';
    } else if (defaultBox) {
      return 'lightpink';
    } else {
      return '#dcdcdc';
    }
  };

  // const handleClickTemp = (e) => {
  //   console.log(e, 'event in temp');
  // };

  return (
    <div
      onClick={() => handleBoxUiClick(box, allowClick, sameBox)}
      // onClick={handleClickTemp}
      onMouseEnter={() => allowClick && setHoverAc(true)}
      onMouseLeave={() => setHoverAc(false)}
      style={{ cursor: 'pointer' }}
    >
      <motion.div
        style={{
          position: 'absolute',
          top: y + actualAddH - 11, //half of (height of circular number + height vertical stem + height horizontal stand)
          left: x + actualAdd - 11, //half of (width of circular number + width vertical stem + width horizontal stand) //9 //13
          right: 'auto',
          bottom: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        variants={tableFramer}
        initial='hidden'
        animate={hoverAc ? 'hover' : 'visible'}
      >
        <div
          //circular num
          style={{
            width: 22, //18 //27
            height: 22, //18 //27
            borderWidth: 1,
            borderRadius: '50%',
            borderStyle: 'solid',
            backgroundColor: bgColor(),
            // textAlign: 'center',
            color: 'black',
            display: 'grid',
            placeItems: 'center',
            fontSize: 9,
          }}
        >
          {box['boxName'].replace('BOX-', '')}
        </div>
        <div style={{ width: 2, height: 2, backgroundColor: 'black' }}></div>
        <div style={{ width: 12, height: 2, backgroundColor: 'black' }}></div>
      </motion.div>
      <area shape='circle' coords={`${x}, ${y}, ${r}`} alt='table1' />
    </div>
  );
}

export default TableArea;
